<div #container class="ad-doc-viewer-container">
    <iframe *ngIf="src" [src]="src" style="width: 100%; height: 100%;" frameborder="0"></iframe>
    <div class="ad-doc-viewer-loading" [hidden]="src">
        <div>
            <div class="ad-doc-viewer-loading-title">Preparing document for viewing...</div>
            <ad-skeleton count="1"></ad-skeleton>
        </div>
    </div>
</div>